<span [ngClass]="params.value == 1 ? 'call_out' : 'call_in'">
  {{ (params.value == 1 ? 'livecall.call_outgoing' : 'livecall.call_incoming') | translate }}
</span>
